import React  from "react";

const LeadLoadingCards =() =>{
    return <>
<div className="leadSearchItemOuter"   >
<div>
<div className="leadCardLeftBox" style={{background:"#f9f9f9"}}>
<div  className="leadCircleBtnLoading"  style={{cursor:"pointer"}}
 ><div className="text-card-full" ></div></div> 
    <div  className="leadCircleBtnLoading " ><div className="text-card-full" ></div>
  </div>
    <div  className="leadCircleBtnLoading"  style={{cursor:"pointer"}}
 ><div className="text-card-full" ></div>
   </div>
</div><div className="dashboardGridBtns"style={{padding:"0px",margin:"0px"}} >

<div className="crm-button-one-loading" style={{cursor:"pointer"}}  
><div className="text-card-full" style={{height:"40px"}} ></div></div>
<div className="crm-button-one-loading" style={{cursor:"pointer"}}  
><div className="text-card-full"style={{height:"40px"}} ></div></div>
</div></div>
<div className="dashboardGridBtns"style={{padding:"0px",margin:"0px"}} >
   <div>
   
   <div className="crm-button-one-loading" style={{cursor:"pointer",height:"30px"}}  
><div className="text-card-full" style={{height:"30px"}} ></div></div>
<div className="crm-button-one-loading" style={{cursor:"pointer",height:"30px"}}  
><div className="text-card-full"style={{height:"30px"}} ></div></div>
   <div className="dashboardGridBtns"style={{padding:"0px",margin:"0px",}} >

  
<div className="crm-button-one-loading" style={{cursor:"pointer"}}  
><div className="text-card-full" style={{height:"50px"}} ></div></div>
<div className="crm-button-one-loading" style={{cursor:"pointer"}}  
><div className="text-card-full"style={{height:"50"}} ></div></div>
</div>
</div> 
<div  className=""style={{background:"#f8f8f8",height:"180px"}}>
<div className="text-card-full" style={{height:"180px"}} ></div>
</div>
</div>
</div></>
}

export default LeadLoadingCards ;